import { updateMemberDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateMemberCallable = getCallable(updateMemberDefinition);
